import contactForm from '../modules/contact/contact-form';
import formTracker from '../modules/utility/form-event-tracker';

if (contactForm.canInit('#contact-us-form')) {
    contactForm.init();
}

if (formTracker.canInit('#contact-us-form')) {
    formTracker.init();
}